// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { Middleware, MiddlewareAPI, SerializedError } from '@reduxjs/toolkit'
import { BaseQueryApi, BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { clearLocalStorage, getUser } from '../../helpers/localStorage'
import { renew } from './axios'
import { Mutex } from 'async-mutex'

export const requestMutex = new Mutex();

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    // const token = getUser()?.jwt
    // if (token) {
    //   headers.set('authorization', `Bearer ${token}`)
    // }
    return headers
  },
})

export const customFetchBase: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => middleware(args, api, extraOptions)

async function middleware(args: string | FetchArgs, api: BaseQueryApi, extraOptions: {}) {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status !== 401)
    return result

  if(requestMutex.isLocked()){
    await requestMutex.waitForUnlock();
    if (getUser())
      result = await baseQuery(args, api, extraOptions)
  } else {
    const release = await requestMutex.acquire();

    try {
      const refreshResult = await renew()
      // Retry the initial query
      console.log(refreshResult)
      result = await baseQuery(args, api, extraOptions);
    } catch(error) {
      clearLocalStorage()
    } finally {
      // release must be called once the mutex should be released again.
      release();
    }
  }

  return result;
}

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
  baseQuery: customFetchBase,
  endpoints: () => ({}),
  tagTypes: ['Promotion', 'PromotionProduct', 'Product', 'holiday', 'TimelineResource', 'Statistics',
    'ShortDescription','Customers','Users', 'Brand', 'groups', 'User', 'groupcustomers', 'about',
    'MeasurementUnitDescriptions', 'ProductGroups', "department_measurements", "department_product_group",
    "productType"],
})

export const rtkQueryErrorInterceptor: Middleware = (api: MiddlewareAPI) => (next) => async (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  return next(action)
}

export function getMessageFromRtkError(error: FetchBaseQueryError | SerializedError): string {
  return 'data' in error ? JSON.stringify((error as any).data) : "unknown error";
}
